import React, { useState } from "react";
import ApiAccess from "../../components/setting/ApiAccess";
import UpdatePaymentInfo from "../../components/modals/UpdatePaymentInfo";

/*
    API MANAGEMENT — the key, the courses it covers, usage and rotation.

    The page is a heading and a panel; everything inside it is ApiAccess,
    which already owns the six states a customer's credentials can be in.

    The payment modal lives here rather than in ApiAccess because the
    suspended-access alert offers "Update payment method" as its way out: a
    suspension is usually a failed payment, and sending the customer to the
    Billing tab to find that out is a worse answer than letting them fix it
    where they hit it.
*/
const ApiManagement = () => {
  const [payment, setPayment] = useState(false);

  // Tolerates being called with no event — UpdatePaymentInfo calls its toggle
  // bare after a successful save. See the same note in Billing.js.
  const togglePayment = (event) => {
    if (event && typeof event.preventDefault === "function") {
      event.preventDefault();
    }
    setPayment((open) => !open);
  };

  return (
    <>
      <h1 className="account__heading">API Management</h1>

      <div className="account__panel">
        <ApiAccess onUpdatePayment={togglePayment} />
      </div>

      <UpdatePaymentInfo
        payment={payment}
        paymentToggle={togglePayment}
        // The card is not shown on this page, so there is nothing here to
        // refresh — Billing re-fetches it when the customer next opens it.
        setCardDetails={() => {}}
      />
    </>
  );
};

export default ApiManagement;
